<header class="section-header">
  <h2>مسافت پیموده‌شده</h2>
  <span>کیلومتر / روز</span>
</header>
<app-chart [context]="chartContext"></app-chart>
<p class="chart-note">مقادیر روزانه مستقیماً از خروجی تحلیل روزانه خوانده می‌شوند.</p>
